/**
 * Buckets used to classify transactions on the Accrual review surface based on
 * the kind of accrual suggestion (if any) available for a transaction.
 *
 * - `INVOICE`: transaction has at least one accrual match suggestion linking it
 *   to an invoice.
 * - `BILL`: transaction has at least one accrual match suggestion linking it to
 *   a bill.
 * - `TRANSFER`: transaction has at least one accrual match suggestion linking
 *   it to another transaction (a transfer pair).
 * - `RULE_SUGGESTED`: an accrual rule has populated `suggestedAccrualAccountId`
 *   on the transaction, the user has not confirmed it yet, and no accrual match
 *   suggestion exists. The suggestion-table buckets take priority so a matched
 *   transaction is reviewed where its match is visible, and is never double
 *   counted under RULE_SUGGESTED.
 * - `NONE`: transaction has neither a rule suggestion nor any accrual match
 *   suggestions.
 *
 * These values power the `accrualSuggestionBuckets` filter on the transactions
 * list and the accrual-review system tasks.
 */
export enum AccrualSuggestionBucket {
    RULE_SUGGESTED = "rule_suggested",
    INVOICE = "invoice",
    BILL = "bill",
    TRANSFER = "transfer",
    NONE = "none",
}
